import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText, vModelSelect as _vModelSelect, unref as _unref, createVNode as _createVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "row pt-3",
  style: {"border-top":"1px dashed rgba(106, 113, 133, 0.3)"}
}
const _hoisted_2 = { class: "col-sm-7" }
const _hoisted_3 = { class: "row h-100" }
const _hoisted_4 = { class: "col h-100" }
const _hoisted_5 = { class: "checkbox-checked d-flex h-100 align-items-center" }
const _hoisted_6 = { class: "form-check" }
const _hoisted_7 = { class: "col h-100" }
const _hoisted_8 = { class: "checkbox-checked d-flex h-100 align-items-center" }
const _hoisted_9 = { class: "form-check" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-sm-5" }
const _hoisted_12 = { class: "mb-3" }
const _hoisted_13 = { class: "col-sm-7" }
const _hoisted_14 = { class: "mb-3" }
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "col-sm-5" }
const _hoisted_17 = { class: "mb-3" }
const _hoisted_18 = { class: "input-group" }
const _hoisted_19 = { class: "row mb-3" }
const _hoisted_20 = { class: "col-5" }
const _hoisted_21 = { class: "input-group" }
const _hoisted_22 = {
  class: "col-sm-7",
  style: {"margin-top":"30px"}
}
const _hoisted_23 = { class: "row h-100" }
const _hoisted_24 = { class: "col h-100" }
const _hoisted_25 = { class: "checkbox-checked d-flex h-100 align-items-center" }
const _hoisted_26 = { class: "form-check" }
const _hoisted_27 = { class: "col h-100" }
const _hoisted_28 = { class: "checkbox-checked d-flex h-100 align-items-center" }
const _hoisted_29 = { class: "form-check" }
const _hoisted_30 = { class: "row" }
const _hoisted_31 = { class: "col-sm-5" }
const _hoisted_32 = { class: "checkbox-checked h-100 d-flex h-100 align-items-center" }
const _hoisted_33 = { class: "form-check" }
const _hoisted_34 = { class: "col-sm-7" }
const _hoisted_35 = { class: "mb-3" }
const _hoisted_36 = { class: "input-group" }

import { computed, reactive, watch, onMounted, defineAsyncComponent } from 'vue'
import { useDepartmentsStore } from '@/store/management/departmentsStore';
import type { Department } from '@/store/management/departmentsStore';


export default /*@__PURE__*/_defineComponent({
  __name: 'departmentsBasic',
  setup(__props) {

const departmentsAltLangModal = defineAsyncComponent(() => import('@/components/managementPages/dapartmentsPage/departmentsAltLangModal.vue'))

const departmentsStore = useDepartmentsStore()

onMounted(() => {
    if (tempActiveDepartment.value?.id) {
        compState.id = tempActiveDepartment.value.id
        compState.name = tempActiveDepartment.value.name
        compState.showOnMenu = tempActiveDepartment.value.showOnMenu
        compState.saleDepartment = tempActiveDepartment.value.saleDepartment
        compState.taxRate = tempActiveDepartment.value.taxRate
        compState.displayOrder = tempActiveDepartment.value.displayOrder
        compState.nonDiscountable = tempActiveDepartment.value.nonDiscountable
        compState.nonSurchargeable = tempActiveDepartment.value.nonSurchargeable
        compState.scaleDepartment = tempActiveDepartment.value.scaleDepartment
        compState.unitOfSale = tempActiveDepartment.value.unitOfSale
        compState.altLangText = altDisplayText(tempActiveDepartment.value.altDisplayLang)
    }
    console.log('tempActiveDepartment', tempActiveDepartment.value);

})

const compState = reactive({
    id: '',
    name: '',
    showOnMenu: false,
    saleDepartment: false,
    taxRate: '',
    displayOrder: 0,
    nonDiscountable: false,
    nonSurchargeable: false,
    scaleDepartment: false,
    unitOfSale: '',
    altLangText: ''
})

const altDisplayText = (langList: String[]) => {
    if (langList) {
        return langList.filter(lang => lang !== '').join('|')
    }
    return ''
}

const activeDepartment = computed(() => {
    return departmentsStore.getActiveDepartment
})

const tempActiveDepartment = computed(() => {
    return departmentsStore.getTempActiveDepartment
})

const activeDepartmentId = computed(() => {
    return departmentsStore.getActiveDepartmentId
})

watch(activeDepartmentId, (newVal) => {
    if (newVal) {
        const department = activeDepartment.value
        compState.id = department.id
        compState.name = department.name
        compState.showOnMenu = department.showOnMenu
        compState.saleDepartment = department.saleDepartment
        compState.taxRate = department.taxRate
        compState.displayOrder = department.displayOrder
        compState.nonDiscountable = department.nonDiscountable
        compState.nonSurchargeable = department.nonSurchargeable
        compState.scaleDepartment = department.scaleDepartment
        compState.unitOfSale = department.unitOfSale
        compState.altLangText = altDisplayText(tempActiveDepartment.value.altDisplayLang)
    }
}, { immediate: true });

watch(compState, (newVal) => {
    departmentsStore.setTempActiveDepartment({
        ...tempActiveDepartment.value,
        id: newVal.id,
        name: newVal.name,
        showOnMenu: newVal.showOnMenu,
        saleDepartment: newVal.saleDepartment,
        taxRate: newVal.taxRate,
        displayOrder: newVal.displayOrder,
        nonDiscountable: newVal.nonDiscountable,
        nonSurchargeable: newVal.nonSurchargeable,
        scaleDepartment: newVal.scaleDepartment,
        unitOfSale: newVal.unitOfSale,
    } as Department)
}, { deep: true });

const displayOrderIncrement = () => {
    compState.displayOrder++
}

const displayOrderDecrement = () => {
    if (compState.displayOrder > 0) {
        compState.displayOrder--
    }
}

const onEditAltLang = () => {
    compState.altLangText = altDisplayText(tempActiveDepartment.value.altDisplayLang)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[12] || (_cache[12] = _createElementVNode("div", { class: "col-sm-5" }, [
        _createElementVNode("div", { class: "mb-3" }, [
          _createElementVNode("h6", { class: "f-w-700 pb-1" }, "Department Number : 10000")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  id: "show-on-menu",
                  type: "checkbox",
                  value: "",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((compState.showOnMenu) = $event))
                }, null, 512), [
                  [_vModelCheckbox, compState.showOnMenu]
                ]),
                _cache[10] || (_cache[10] = _createElementVNode("label", {
                  class: "form-check-label",
                  for: "show-on-menu"
                }, "Show on Menu", -1))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  id: "sele-department",
                  type: "checkbox",
                  value: "",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((compState.saleDepartment) = $event))
                }, null, 512), [
                  [_vModelCheckbox, compState.saleDepartment]
                ]),
                _cache[11] || (_cache[11] = _createElementVNode("label", {
                  class: "form-check-label",
                  for: "sele-department"
                }, "Sale Department", -1))
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _cache[13] || (_cache[13] = _createElementVNode("label", null, [
            _createElementVNode("h6", { class: "f-w-700" }, "Department Name")
          ], -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((compState.name) = $event)),
            class: "form-control",
            type: "text",
            placeholder: "Name",
            maxlength: "32"
          }, null, 512), [
            [_vModelText, compState.name]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _cache[14] || (_cache[14] = _createElementVNode("label", null, [
            _createElementVNode("h6", { class: "f-w-700" }, "Alternative Display Language")
          ], -1)),
          _withDirectives(_createElementVNode("input", {
            class: "form-control",
            type: "text",
            placeholder: "Alternative Display Language",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((compState.altLangText) = $event)),
            maxlength: "32",
            readonly: "",
            "data-bs-toggle": "modal",
            "data-original-title": "test",
            "data-bs-target": "#alt-lang-modal"
          }, null, 512), [
            [_vModelText, compState.altLangText]
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _cache[16] || (_cache[16] = _createElementVNode("label", null, [
            _createElementVNode("h6", { class: "f-w-700" }, "Rate")
          ], -1)),
          _createElementVNode("div", _hoisted_18, [
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((compState.taxRate) = $event)),
              class: "form-select",
              "aria-label": "Tax Rate"
            }, _cache[15] || (_cache[15] = [
              _createElementVNode("option", { value: "" }, "Tax Rate", -1),
              _createElementVNode("option", { value: "Tax" }, "Tax", -1),
              _createElementVNode("option", { value: "Tax2" }, "Tax2", -1),
              _createElementVNode("option", { value: "Tax3" }, "Tax3", -1)
            ]), 512), [
              [_vModelSelect, compState.taxRate]
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, [
        _cache[17] || (_cache[17] = _createElementVNode("label", null, [
          _createElementVNode("h6", { class: "f-w-700" }, "Display Order")
        ], -1)),
        _createElementVNode("div", _hoisted_21, [
          _withDirectives(_createElementVNode("input", {
            class: "form-control",
            type: "number",
            placeholder: "Threshold",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((compState.displayOrder) = $event))
          }, null, 512), [
            [_vModelText, compState.displayOrder]
          ]),
          _createElementVNode("button", {
            class: "btn btn-outline-secondary rounded-end-0",
            type: "button",
            onClick: displayOrderDecrement
          }, "-"),
          _createElementVNode("button", {
            class: "btn btn-outline-secondary rounded-start-0",
            type: "button",
            onClick: displayOrderIncrement
          }, "+")
        ])
      ]),
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  id: "service-check",
                  type: "checkbox",
                  value: "",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((compState.nonDiscountable) = $event))
                }, null, 512), [
                  [_vModelCheckbox, compState.nonDiscountable]
                ]),
                _cache[18] || (_cache[18] = _createElementVNode("label", {
                  class: "form-check-label",
                  for: "service-check"
                }, "Non-Discountable", -1))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  id: "surchargeable-check",
                  type: "checkbox",
                  value: "",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((compState.nonSurchargeable) = $event))
                }, null, 512), [
                  [_vModelCheckbox, compState.nonSurchargeable]
                ]),
                _cache[19] || (_cache[19] = _createElementVNode("label", {
                  class: "form-check-label",
                  for: "surchargeable-check"
                }, "Non-Surchargeable", -1))
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_30, [
      _createElementVNode("div", _hoisted_31, [
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, [
            _withDirectives(_createElementVNode("input", {
              class: "form-check-input",
              id: "scale-check",
              type: "checkbox",
              value: "",
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((compState.scaleDepartment) = $event))
            }, null, 512), [
              [_vModelCheckbox, compState.scaleDepartment]
            ]),
            _cache[20] || (_cache[20] = _createElementVNode("label", {
              class: "form-check-label",
              for: "scale-check"
            }, "Scale Department", -1))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_34, [
        _createElementVNode("div", _hoisted_35, [
          _cache[22] || (_cache[22] = _createElementVNode("label", null, [
            _createElementVNode("h6", { class: "f-w-700" }, "Unit of Sale")
          ], -1)),
          _createElementVNode("div", _hoisted_36, [
            _withDirectives(_createElementVNode("select", {
              class: "form-select",
              "aria-label": "Tax Rate",
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((compState.unitOfSale) = $event))
            }, _cache[21] || (_cache[21] = [
              _createStaticVNode("<option value=\"\" data-v-378041d6>Unit of Sale</option><option value=\"Individually\" data-v-378041d6>Individually</option><option value=\"Gram\" data-v-378041d6>Gram</option><option value=\"Kilogram\" data-v-378041d6>Kilogram</option><option value=\"Ounce\" data-v-378041d6>Ounce</option><option value=\"Pound\" data-v-378041d6>Pound</option><option value=\"Milliliter\" data-v-378041d6>Milliliter</option><option value=\"Liter\" data-v-378041d6>Liter</option><option value=\"Pint\" data-v-378041d6>Pint</option><option value=\"Quart\" data-v-378041d6>Quart</option><option value=\"Gallon\" data-v-378041d6>Gallon</option>", 11)
            ]), 512), [
              [_vModelSelect, compState.unitOfSale]
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_unref(departmentsAltLangModal), { onOnSave: onEditAltLang })
  ], 64))
}
}

})